module.exports = __webpack_public_path__ + "static/img/logo_23.132330d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_23.png
// module id = /4OH
// module chunks = 1